export const environment = {
  production: false,
  api_url: "https://staging.api.wanderflare.com/customer_api"
};
